// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navigation */
.main-nav {
  background-color: #1a1a1a;
  padding: 20px 0;
  border-bottom: 1px solid #333;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 0;
  padding: 0;
}

.nav-links li {
  display: flex;
  align-items: center;
}

.nav-links a {
  color: #a0a0a0;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.nav-links a:hover,
.nav-links a.active {
  color: white;
}


.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 100px 0;
  background-color: #1a1a1a;
}

.hero-content {
  max-width: 800px;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 20px;
  color: #a0a0a0;
}

.hero-tagline {
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 40px;
  color: #a0a0a0;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn {
  display: inline-block;
  padding: 15px 30px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.btn-primary {
  background-color: #5865F2;
  color: white;
}

.btn-primary:hover {
  background-color: #4752c4;
}

.btn-secondary {
  background-color: #333;
  color: white;
}

.btn-secondary:hover {
  background-color: #444;
}

.btn-small {
  padding: 8px 16px;
  font-size: 0.9rem;
  background-color: #5865F2;
  color: white;
}

.btn-small:hover {
  background-color: #4752c4;
}

/* Guilds Section */
.guilds-section {
  padding: 60px 0;
  background-color: #111;
}

.section-subtitle {
  text-align: center;
  color: #a0a0a0;
  margin-top: -50px;
  margin-bottom: 50px;
}

.guilds-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.guild-card {
  background-color: #222;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s ease;
}

.guild-card:hover {
  transform: translateY(-5px);
}

.guild-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
}

.guild-name {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.no-guilds {
  text-align: center;
  color: #a0a0a0;
  font-style: italic;
}

/* Features Section */
.features-section {
  padding: 80px 0;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.feature-card {
  background-color: #222;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.feature-card:hover {
  border-color: #5865F2;
  transform: translateY(-3px);
}

.feature-card-active {
  border-color: #5865F2;
}

.feature-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.feature-card p {
  color: #a0a0a0;
}

.feature-card-hint {
  display: inline-block;
  margin-top: 16px;
  font-size: 0.8rem;
  color: #5865F2;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Feature Preview Panel */
.feature-preview {
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 30px;
  margin-top: 30px;
  animation: previewSlideDown 0.3s ease;
}

@keyframes previewSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.feature-preview-img {
  max-width: 100%;
  border-radius: 8px;
}

/* Discord Message Styles */
.discord-messages-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discord-message {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.discord-message-continued {
  padding-left: 56px;
}

.discord-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #5865F2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.discord-message-content {
  flex: 1 1;
  min-width: 0;
}

.discord-author {
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.discord-bot-tag {
  background-color: #5865F2;
  color: white;
  font-size: 0.65rem;
  padding: 1px 5px;
  border-radius: 3px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.discord-command {
  color: #a0a0a0;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 0.9rem;
  margin-bottom: 8px;
  background-color: #2f3136;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
}

.discord-embed {
  background-color: #2f3136;
  border-left: 4px solid #5865F2;
  border-radius: 4px;
  padding: 16px;
  max-width: 520px;
  margin-top: 4px;
}

.discord-embed-blue { border-left-color: #5865F2; }
.discord-embed-green { border-left-color: #57F287; }
.discord-embed-yellow { border-left-color: #FEE75C; }
.discord-embed-red { border-left-color: #ED4245; }

.discord-embed-title {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 10px;
  color: white;
}

.discord-embed-description {
  color: #dcddde;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 10px;
}

.discord-embed-description strong {
  color: white;
}

.matchup-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.team-name {
  font-weight: 600;
  color: white;
  font-size: 0.95rem;
}

.matchup-score {
  font-weight: 700;
  font-size: 1.3rem;
  color: #5865F2;
}

.matchup-vs {
  color: #72767d;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.discord-embed-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.discord-embed-field {
  flex: 1 1;
  min-width: 140px;
}

.discord-embed-fields-inline {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.discord-embed-field-inline {
  text-align: center;
}

.discord-field-name {
  font-weight: 600;
  font-size: 0.8rem;
  color: #a0a0a0;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
}

.discord-field-value {
  font-size: 0.9rem;
  color: #dcddde;
  line-height: 1.6;
}

.discord-embed-footer {
  margin-top: 12px;
  font-size: 0.75rem;
  color: #72767d;
}

/* Legal Pages */
.legal-page {
  padding: 40px 0;
}

.legal-page h1, .legal-page h2 {
  font-weight: 700;
  margin-bottom: 20px;
}

.legal-page h1 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 40px;
}

.legal-page h2 {
  font-size: 1.8rem;
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
  margin-top: 40px;
}

.legal-page p, .legal-page li {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #a0a0a0;
}

.legal-page ul {
  padding-left: 20px;
}

.legal-page a {
  color: #5865F2;
}


/* Fantasy Providers Section */
.fantasy-providers-section {
  padding: 40px 0;
  margin-bottom: 40px;
}

.provider-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

.provider-card {
  background-color: #222;
  padding: 25px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #333;
}

.provider-card h3 {
  margin-top: 0;
  margin-bottom: 20px;
}

.btn-yahoo {
  background-color: #410093;
  color: white;
  width: 100%;
  cursor: pointer;
  border: none;
}

.btn-yahoo:hover {
  background-color: #5200b8;
}

.status-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.status-badge.connected {
  background-color: rgba(87, 242, 135, 0.1);
  color: #57f287;
  border: 1px solid #57f287;
}

/* Media Queries */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .nav-links {
    gap: 15px;
  }

  .user-menu-trigger span {
    display: none;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .hero-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    box-sizing: border-box;
  }

  .feature-preview {
    padding: 20px;
  }

  .discord-embed {
    max-width: 100%;
  }

  .discord-embed-fields-inline {
    grid-template-columns: repeat(2, 1fr);
  }

  .matchup-header {
    justify-content: center;
  }

  .discord-message-continued {
    padding-left: 0;
  }
}

/* Profile Page */
.profile-page {
  padding-top: 40px;
  padding-bottom: 80px;
}

.user-profile-header {
  display: flex;
  align-items: center;
  gap: 30px;
  background-color: #222;
  padding: 40px;
  border-radius: 15px;
  margin-bottom: 60px;
}

.user-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid #5865F2;
}

.user-details h1 {
  margin: 0 0 10px 0;
  font-size: 2.2rem;
}

.user-details p {
  margin: 0;
  color: #a0a0a0;
  font-size: 1.1rem;
}

.guild-actions {
  display: flex;
  gap: 10px;
  width: 100%;
}

.guild-actions .btn {
  flex: 1 1;
}

.error-message {
  color: #ff4757;
  background-color: rgba(255, 71, 87, 0.1);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
}

/* Modal Styling - REMOVED since config is now a standalone page */

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #a0a0a0;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px;
  background-color: #111;
  border: 1px solid #333;
  border-radius: 5px;
  color: white;
  font-size: 1rem;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #5865F2;
}

.btn-link:hover {
  color: white !important;
  text-decoration: underline;
}

/* User Dropdown */
.user-menu-container {
  position: relative;
  display: flex;
  align-items: center;
}

.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  color: white;
  font-weight: 600;
}

.user-menu-trigger:hover {
  background-color: #2a2a2a;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #222;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.5);
  z-index: 100;
  border-radius: 8px;
  margin-top: 10px;
  border: 1px solid #333;
  overflow: hidden;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

.user-menu-container:hover .dropdown-menu,
.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  color: #a0a0a0;
  padding: 10px 20px;
  text-decoration: none;
  display: block;
  font-weight: 600;
  transition: all 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-size: 0.95rem;
}

.dropdown-item:hover {
  background-color: #333;
  color: white;
  padding-left: 25px;
}

.dropdown-item.active {
  color: white;
  background-color: #2a2a2a;
}

.dropdown-divider {
  height: 1px;
  background-color: #333;
  margin: 8px 0;
}

/* Auth / Callback Card Styles */
.auth-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 20px 0;
}

.auth-card {
  background-color: #222;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 40px 30px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.auth-card-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
}

.auth-card-icon.error {
  background-color: rgba(255, 71, 87, 0.15);
  color: #ff4757;
  border: 1px solid rgba(255, 71, 87, 0.3);
}

.auth-card-icon.loading {
  background-color: rgba(88, 101, 242, 0.15);
  color: #5865F2;
  border: 1px solid rgba(88, 101, 242, 0.3);
}

.spinner-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.auth-card-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  color: #ffffff;
}

.auth-card-subtitle {
  color: #a0a0a0;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.auth-card-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.auth-card-actions .btn {
  width: 100%;
  box-sizing: border-box;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,yBAAyB;EACzB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB,0BAA0B,EAAE;AAClD,uBAAuB,0BAA0B,EAAE;AACnD,wBAAwB,0BAA0B,EAAE;AACpD,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA,8BAA8B;AAC9B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["/* Navigation */\n.main-nav {\n  background-color: #1a1a1a;\n  padding: 20px 0;\n  border-bottom: 1px solid #333;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.nav-links {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-links li {\n  display: flex;\n  align-items: center;\n}\n\n.nav-links a {\n  color: #a0a0a0;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n  display: flex;\n  align-items: center;\n}\n\n.nav-links a:hover,\n.nav-links a.active {\n  color: white;\n}\n\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Hero Section */\n.hero-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 100px 0;\n  background-color: #1a1a1a;\n}\n\n.hero-content {\n  max-width: 800px;\n}\n\n.hero-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.hero-subtitle {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 20px;\n  color: #a0a0a0;\n}\n\n.hero-tagline {\n  font-size: 1rem;\n  font-weight: 400;\n  margin-bottom: 40px;\n  color: #a0a0a0;\n}\n\n.hero-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.btn {\n  display: inline-block;\n  padding: 15px 30px;\n  border-radius: 5px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.btn-primary {\n  background-color: #5865F2;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #4752c4;\n}\n\n.btn-secondary {\n  background-color: #333;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #444;\n}\n\n.btn-small {\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  background-color: #5865F2;\n  color: white;\n}\n\n.btn-small:hover {\n  background-color: #4752c4;\n}\n\n/* Guilds Section */\n.guilds-section {\n  padding: 60px 0;\n  background-color: #111;\n}\n\n.section-subtitle {\n  text-align: center;\n  color: #a0a0a0;\n  margin-top: -50px;\n  margin-bottom: 50px;\n}\n\n.guilds-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.guild-card {\n  background-color: #222;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  transition: transform 0.2s ease;\n}\n\n.guild-card:hover {\n  transform: translateY(-5px);\n}\n\n.guild-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.guild-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.no-guilds {\n  text-align: center;\n  color: #a0a0a0;\n  font-style: italic;\n}\n\n/* Features Section */\n.features-section {\n  padding: 80px 0;\n}\n\n.section-title {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 60px;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.feature-card {\n  background-color: #222;\n  padding: 40px;\n  border-radius: 10px;\n  text-align: center;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.feature-card:hover {\n  border-color: #5865F2;\n  transform: translateY(-3px);\n}\n\n.feature-card-active {\n  border-color: #5865F2;\n}\n\n.feature-card h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.feature-card p {\n  color: #a0a0a0;\n}\n\n.feature-card-hint {\n  display: inline-block;\n  margin-top: 16px;\n  font-size: 0.8rem;\n  color: #5865F2;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Feature Preview Panel */\n.feature-preview {\n  background-color: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 30px;\n  margin-top: 30px;\n  animation: previewSlideDown 0.3s ease;\n}\n\n@keyframes previewSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.feature-preview-img {\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n/* Discord Message Styles */\n.discord-messages-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.discord-message {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.discord-message-continued {\n  padding-left: 56px;\n}\n\n.discord-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #5865F2;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.discord-message-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.discord-author {\n  font-weight: 600;\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.discord-bot-tag {\n  background-color: #5865F2;\n  color: white;\n  font-size: 0.65rem;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.discord-command {\n  color: #a0a0a0;\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n  background-color: #2f3136;\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.discord-embed {\n  background-color: #2f3136;\n  border-left: 4px solid #5865F2;\n  border-radius: 4px;\n  padding: 16px;\n  max-width: 520px;\n  margin-top: 4px;\n}\n\n.discord-embed-blue { border-left-color: #5865F2; }\n.discord-embed-green { border-left-color: #57F287; }\n.discord-embed-yellow { border-left-color: #FEE75C; }\n.discord-embed-red { border-left-color: #ED4245; }\n\n.discord-embed-title {\n  font-weight: 600;\n  font-size: 1rem;\n  margin-bottom: 10px;\n  color: white;\n}\n\n.discord-embed-description {\n  color: #dcddde;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n\n.discord-embed-description strong {\n  color: white;\n}\n\n.matchup-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n\n.team-name {\n  font-weight: 600;\n  color: white;\n  font-size: 0.95rem;\n}\n\n.matchup-score {\n  font-weight: 700;\n  font-size: 1.3rem;\n  color: #5865F2;\n}\n\n.matchup-vs {\n  color: #72767d;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.discord-embed-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.discord-embed-field {\n  flex: 1;\n  min-width: 140px;\n}\n\n.discord-embed-fields-inline {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.discord-embed-field-inline {\n  text-align: center;\n}\n\n.discord-field-name {\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: #a0a0a0;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 4px;\n}\n\n.discord-field-value {\n  font-size: 0.9rem;\n  color: #dcddde;\n  line-height: 1.6;\n}\n\n.discord-embed-footer {\n  margin-top: 12px;\n  font-size: 0.75rem;\n  color: #72767d;\n}\n\n/* Legal Pages */\n.legal-page {\n  padding: 40px 0;\n}\n\n.legal-page h1, .legal-page h2 {\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.legal-page h1 {\n  font-size: 2.5rem;\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.legal-page h2 {\n  font-size: 1.8rem;\n  border-bottom: 1px solid #333;\n  padding-bottom: 10px;\n  margin-top: 40px;\n}\n\n.legal-page p, .legal-page li {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #a0a0a0;\n}\n\n.legal-page ul {\n  padding-left: 20px;\n}\n\n.legal-page a {\n  color: #5865F2;\n}\n\n\n/* Fantasy Providers Section */\n.fantasy-providers-section {\n  padding: 40px 0;\n  margin-bottom: 40px;\n}\n\n.provider-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.provider-card {\n  background-color: #222;\n  padding: 25px;\n  border-radius: 12px;\n  text-align: center;\n  border: 1px solid #333;\n}\n\n.provider-card h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.btn-yahoo {\n  background-color: #410093;\n  color: white;\n  width: 100%;\n  cursor: pointer;\n  border: none;\n}\n\n.btn-yahoo:hover {\n  background-color: #5200b8;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.status-badge.connected {\n  background-color: rgba(87, 242, 135, 0.1);\n  color: #57f287;\n  border: 1px solid #57f287;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .nav-links {\n    gap: 15px;\n  }\n\n  .user-menu-trigger span {\n    display: none;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .feature-preview {\n    padding: 20px;\n  }\n\n  .discord-embed {\n    max-width: 100%;\n  }\n\n  .discord-embed-fields-inline {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .matchup-header {\n    justify-content: center;\n  }\n\n  .discord-message-continued {\n    padding-left: 0;\n  }\n}\n\n/* Profile Page */\n.profile-page {\n  padding-top: 40px;\n  padding-bottom: 80px;\n}\n\n.user-profile-header {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  background-color: #222;\n  padding: 40px;\n  border-radius: 15px;\n  margin-bottom: 60px;\n}\n\n.user-avatar {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  border: 3px solid #5865F2;\n}\n\n.user-details h1 {\n  margin: 0 0 10px 0;\n  font-size: 2.2rem;\n}\n\n.user-details p {\n  margin: 0;\n  color: #a0a0a0;\n  font-size: 1.1rem;\n}\n\n.guild-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n\n.guild-actions .btn {\n  flex: 1;\n}\n\n.error-message {\n  color: #ff4757;\n  background-color: rgba(255, 71, 87, 0.1);\n  padding: 15px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* Modal Styling - REMOVED since config is now a standalone page */\n\n.form-group {\n  margin-bottom: 25px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #a0a0a0;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 12px;\n  background-color: #111;\n  border: 1px solid #333;\n  border-radius: 5px;\n  color: white;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #5865F2;\n}\n\n.btn-link:hover {\n  color: white !important;\n  text-decoration: underline;\n}\n\n/* User Dropdown */\n.user-menu-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.user-menu-trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n  color: white;\n  font-weight: 600;\n}\n\n.user-menu-trigger:hover {\n  background-color: #2a2a2a;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #222;\n  min-width: 180px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.5);\n  z-index: 100;\n  border-radius: 8px;\n  margin-top: 10px;\n  border: 1px solid #333;\n  overflow: hidden;\n  padding: 8px 0;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n}\n\n.user-menu-container:hover .dropdown-menu,\n.dropdown-menu.show {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.dropdown-item {\n  color: #a0a0a0;\n  padding: 10px 20px;\n  text-decoration: none;\n  display: block;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n\n.dropdown-item:hover {\n  background-color: #333;\n  color: white;\n  padding-left: 25px;\n}\n\n.dropdown-item.active {\n  color: white;\n  background-color: #2a2a2a;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background-color: #333;\n  margin: 8px 0;\n}\n\n/* Auth / Callback Card Styles */\n.auth-card-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  padding: 20px 0;\n}\n\n.auth-card {\n  background-color: #222;\n  border: 1px solid #333;\n  border-radius: 12px;\n  padding: 40px 30px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.auth-card-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px auto;\n}\n\n.auth-card-icon.error {\n  background-color: rgba(255, 71, 87, 0.15);\n  color: #ff4757;\n  border: 1px solid rgba(255, 71, 87, 0.3);\n}\n\n.auth-card-icon.loading {\n  background-color: rgba(88, 101, 242, 0.15);\n  color: #5865F2;\n  border: 1px solid rgba(88, 101, 242, 0.3);\n}\n\n.spinner-icon {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.auth-card-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0 0 10px 0;\n  color: #ffffff;\n}\n\n.auth-card-subtitle {\n  color: #a0a0a0;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0 0 20px 0;\n}\n\n.auth-card-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.auth-card-actions .btn {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
